import {
  Availability,
  SearchOperatorOptions,
  SearchOption
} from '@components/show_page/sections/section_search/SearchTypes';

export const searchOptions = (isNarrowView = false): SearchOption[] => ([
  { label: isNarrowView ? bfTranslate('Any') : bfTranslate('Any of these terms'), value: SearchOperatorOptions.OR },
  { label: isNarrowView ? bfTranslate('All') : bfTranslate('All of these terms'), value: SearchOperatorOptions.AND },
  { label: isNarrowView ? bfTranslate('Contains') : bfTranslate('Contains this phrase'), value: SearchOperatorOptions.Quoted },
  { label: isNarrowView ? bfTranslate('Exact') : bfTranslate('Exactly this phrase'), value: SearchOperatorOptions.Strict },
]);

export const assetStatusOptions = [
  { label: bfTranslate('All'), value: undefined },
  { label: bfTranslate('Approved'), value: Availability.Approved },
  { label: bfTranslate('Unapproved'), value: Availability.Unapproved },
  { label: bfTranslate('Draft'), value: Availability.Draft },
  { label: bfTranslate('Expired'), value: Availability.Expired }
];
